import React, { useCallback, useEffect, useRef } from 'react';
import { GlobalStyle } from '../../styles/global';
import logoImg from '../../assets/metodo-billings-marca-dashboard.png';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import Input from '../../components/Elements/Input';
import Button from '../../components/Elements/Button';
import { Container } from '../SignIn/styles';
import getValidationErros from '../../utils/getValidationErros';
import {api} from '../../services/api';
import toast from 'react-hot-toast';
import { useParams } from "react-router-dom";

interface ResetPassFormData{
    email: string;
    pass: string;
    repass: string;
    skey: string
}

interface DataUser{
    key: string
  }

const ResetPass: React.FC = () => {

    const { key } = useParams<DataUser>();

    const formRef = useRef<FormHandles>(null);
    const history = useHistory();

    const handleSubcribe = useCallback(async (data: ResetPassFormData) => {
      if(data.pass === data.repass){
        try {
            formRef.current?.setErrors({});
            const schema = Yup.object().shape({
                email: Yup.string().required('Email obrigatório').email('Insira um email válido').min(5, 'Mínimo 5 caracteres'),
                pass: Yup.string().required('Senha Obrigatória').min(6, 'Mínimo 6 caracteres').max(12, 'Máximo de 12 caracteres'),
                repass: Yup.string().required('Senha Obrigatória').min(6, 'Mínimo 6 caracteres').max(12, 'Máximo de 12 caracteres'),
                skey: Yup.string(),
            });
            await schema.validate(data, { abortEarly: false, });

            await api.post('redefinir.php', data);
            toast.success('SUCESSO, FAÇA AGORA SEU LOGON');
            // console.log(resp);
            history.push('/');
            

        } catch (err : any) {
          if(err instanceof Yup.ValidationError){
            const errors = getValidationErros(err);
            formRef.current?.setErrors(errors);
            return;
          }
          
          const resp = err.response.statusText;
                          
          toast.error('ERRO AO REDEFINIR: ' + resp);
        }
      } else {
        toast.error('ERRO, AS SENHAS NÃO SÃO IGUAIS');
      }
    }, [history]);

    useEffect(() => {
        if(key === '' || key === null || key === undefined){
            history.push('/');
        }
    }, [key, history])
   
    return ( 
    <>
        <Container>
            <img src={logoImg} alt="Método Billings" />
            <br />
            <h3>REDEFINIR SENHA</h3>
            <Form ref={formRef} onSubmit={handleSubcribe}>
                <Input type="text" name="email" placeholder="SEU EMAIL" />
                <Input type="password" name='pass' placeholder="SUA SENHA" />
                <Input type="password" name='repass' placeholder="SUA SENHA NOVAMENTE" />
                <Input type="hidden" name="skey" defaultValue={key} />
                <Button type="submit">redefinir senha</Button>                
            

                <div className="outros">
                    <a href="/" className="botao">Fazer login</a>
                    <a href="/cadastrar" className="botao">Cadastrar</a>
                </div>
            </Form>
        </Container>
        <GlobalStyle />
    </>
    );
}

export default ResetPass;